export default __webpack_public_path__ + "static/media/more-horiz-24px.973a6463.svg";